import { Icon } from '@iconify/react';
import homeFill from '@iconify/icons-eva/home-fill';
import fileFill from '@iconify/icons-eva/file-fill';
// routes
import { PATH_PUBLIC } from 'routes/paths';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22
};

const menuConfig = [
  {
    title: 'Home',
    path: '/',
    icon: <Icon icon={homeFill} {...ICON_SIZE} />
  },
  { title: 'Features', path: PATH_PUBLIC.public.features},
  { title: 'Communication', path: PATH_PUBLIC.public.communication},
  { title: 'Security', path: PATH_PUBLIC.public.security },
  { title: 'Community', path: PATH_PUBLIC.public.community }
  // { title: 'Faq', path: PATH_PUBLIC.public.faq},

  
];

export default menuConfig;
